import {apiRequest} from './client';
import type {
    AcceptInviteResponse,
    InviteInfo,
    InviteResult,
    InviteTeamMemberRequest,
    TeamMember,
    UpdateTeamMemberRequest
} from '@/types/api';

export async function getTeamMembers(): Promise<TeamMember[]> {
    return apiRequest<TeamMember[]>('/team', {
        method: 'GET'
    });
}

export async function getTeamMember(id: string): Promise<TeamMember> {
    return apiRequest<TeamMember>(`/team/${id}`, {
        method: 'GET'
    });
}

export async function inviteTeamMember(data: InviteTeamMemberRequest): Promise<InviteResult> {
    return apiRequest<InviteResult>('/team', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export async function updateTeamMember(id: string, data: UpdateTeamMemberRequest): Promise<TeamMember> {
    return apiRequest<TeamMember>(`/team/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data)
    });
}

export async function removeTeamMember(id: string): Promise<{ message: string }> {
    return apiRequest<{ message: string }>(`/team/${id}`, {
        method: 'DELETE'
    });
}

export async function retrySyncForMember(id: string): Promise<Array<{ siteId: string; siteName: string; status: string; error?: string }>> {
    return apiRequest<Array<{ siteId: string; siteName: string; status: string; error?: string }>>(`/team/${id}/retry-sync`, {
        method: 'POST'
    });
}

export async function resendInvite(id: string): Promise<{ message: string }> {
    return apiRequest<{ message: string }>(`/team/${id}/resend-invite`, {
        method: 'POST'
    });
}

export async function getInviteInfo(token: string): Promise<InviteInfo> {
    return apiRequest<InviteInfo>(`/team/invite/info?token=${encodeURIComponent(token)}`, {
        method: 'GET'
    });
}

export async function acceptInvite(token: string): Promise<AcceptInviteResponse> {
    return apiRequest<AcceptInviteResponse>('/team/invite/accept', {
        method: 'POST',
        body: JSON.stringify({token})
    });
}

export async function completeAccept(teamMemberId: string): Promise<{ message: string }> {
    return apiRequest<{ message: string }>('/team/invite/complete', {
        method: 'POST',
        body: JSON.stringify({teamMemberId})
    });
}
